<template>
    <div
        class="relative flex flex-col min-h-full p-2 bg-white shadow-md rounded-3xl shadow-black/5 ring-1 ring-black/5">
        <a v-if="post.featuredImageUrl" :href="`/blog/${post.slug}`" :alt="post.title" :title="post.title">
            <img :src="post.featuredImageUrl" :alt="post.title" :title="post.title"
                class="aspect-[3/2] w-full rounded-2xl object-cover">
        </a>
        <div class="flex flex-col flex-1 p-8">
            <div class="text-gray-700 text-sm/5 blog-tag-list">

                <span v-for="category in post.categories" :key="category"
                    class="z-10 py-1 mr-1 text-xs font-medium rounded-full text-sa-raspberry-900">
                    <a :href="`/blog/?categories=${category}`" :title="category">{{ category }}</a>
                </span>
            </div>
            <div class="mt-2 font-medium text-base/7">
                <a :href="`/blog/${post.slug}`" :alt="post.title" :title="post.title"><span
                        class="absolute inset-0"></span>
                    <h3 class="">{{ post.title }}</h3>
                </a>
            </div>
            <div class="flex-1 mt-2 text-gray-600 text-sm/6">{{ post.excerpt }}</div>
            <div class="z-10 flex items-center gap-3 mt-6">
                <a v-for="author in post.authors" :key="author.slug" :href="`/author/${author.slug}`">
                    <img class="object-cover rounded-full aspect-square size-6" :src="author.headshotUrl"
                        :alt="author.name">
                </a>


                <div class="text-gray-700 text-sm/5">By
                    <a v-for="author in post.authors" :key="author.slug" :href="`/author/${author.slug}`"
                        class="hover:underline">
                        {{ author.name }}
                    </a>
                    <p  class="text-sm">{{ post.publishedOnAsString }}</p>
                </div>
                <div class="z-10 shrink-0 mt-2 ml-4">
                    <div class="relative inline-flex items-center">
                        <Bookmarking :id="post.id"></Bookmarking>
                    </div>
                </div>
            </div>
        </div>
    </div>







</template>

<script lang="ts" setup>
import {defineProps} from "vue";
import {BlogPostDtoLightweight} from "@/dtos";
import Bookmarking from "@/main/components/Bookmarking.vue";

const props = defineProps<{
    post: BlogPostDtoLightweight,
}>();

const post: BlogPostDtoLightweight = props.post;

</script>
<style>

</style>